import { Injectable } from '@angular/core';
import { IBoundingBoxModel } from 'src/app/core/models/models';
import { Observable } from 'rxjs';
import { EnvironmentService } from 'src/app/environment.service';
import { HttpClient } from '@angular/common/http';
import { RequestModel } from 'src/app/modules/route-planner/models/route-signposts-model';
import { TRAVEL_TYPE } from 'src/app/modules/maps-hotels/models/maps-hotels-model';

export interface IGoogleMapHTTPService {
  getRouteSignspots(roadRequestModel: RequestModel.SignpostsRequestModel): Observable<any>;
  getMemberBenefits(memberRequestModel: RequestModel.MemberBenefitModel): Observable<any>;
  getTravel(boundingBox: IBoundingBoxModel): Observable<any>;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleMapHTTPService {
  private autoCompleteService = new google.maps.places.AutocompleteService();

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  private rangeSet = `search/signpost/v1/range-set`;
  private memberBenefits = `search/benefits/v1/range-set`;
  private travelSet = `search/travel/v1/bounding-box`;
  private serviceStation = `search/travel/v1/line-intersect?travelType=SS`;

  public getRouteSignspots(roadRequestModel: RequestModel.SignpostsRequestModel): Observable<any> {
    return this.http.post(
      this.envService.routeModel.apiBaseUrl + this.rangeSet, roadRequestModel
    );
  }

  public getMemberBenefits(memberRequestModel: RequestModel.MemberBenefitModel): Observable<any> {
    return this.http.post(
      this.envService.routeModel.apiBaseUrl + this.memberBenefits, memberRequestModel
    );
  }

  public getTravel(boundingBox: IBoundingBoxModel, travelTypes: Array<TRAVEL_TYPE> = []): Observable<any> {
    let travelTypeQuery = '?';
    travelTypes.forEach( type => {
      travelTypeQuery += `travelType=${type}&`;
    });
    travelTypeQuery = travelTypeQuery.slice(0, -1);
    return this.http.post(
      this.envService.routeModel.apiBaseUrl + this.travelSet + travelTypeQuery, boundingBox
    );
  }

  public getServiceStation(poliline): Observable<any> {
    // console.log('poliline:', decodeURIComponent(poliline) );
    return this.http.post(
      this.envService.routeModel.apiBaseUrl + this.serviceStation,
      {'polyline': decodeURIComponent(poliline)}
    );
  }

  /**
   * South, West - Bottom, Left
   * North, East - Top, Right
   * West - Left
   */
  public getTrafficNewsData(boundingBox: IBoundingBoxModel, incidentTypes: Array<string> = []): Observable<any> {
    let incidentQuery = '?';
    incidentTypes.forEach(element => {
      incidentQuery += `incidentType=${element}&`;
    });
    incidentQuery = incidentQuery.slice(0, -1);

    return this.http.post(
      this.envService.routeModel.apiBaseUrl + this.envService.routeModel.traffic + incidentQuery, boundingBox
    );
  }

  public getParkingData(boundingBox: IBoundingBoxModel): Observable<any> {
    return this.http.post(
      this.envService.routeModel.apiBaseUrl + this.envService.routeModel.parking, boundingBox
    );
  }

  public getChangeFromPlace(inputKey: string): Observable<any>  {
    const bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(49.5, -10.6),
      new google.maps.LatLng(61, 2)
    );

    return new Observable( (observer) => {
      this.autoCompleteService.getPlacePredictions( {input: inputKey, bounds: bounds}, (data) => {
          observer.next(data);
        });
    });
  }

}
